define("shared/utils/media-adjustments/has-unsaved-media-spec-changes", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hasUnsavedMediaSpecChanges = hasUnsavedMediaSpecChanges;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function hasUnsavedMediaSpecChanges(postMediaItem) {
    const changed = postMediaItem.changedAttributes();
    return Boolean(changed.cropArray || changed.transformation);
  }
});